import { render, staticRenderFns } from "./PopupSuggestedExerciseSwapContainerAlternatives.vue?vue&type=template&id=1658a9c2&scoped=true"
import script from "./PopupSuggestedExerciseSwapContainerAlternatives.vue?vue&type=script&lang=js"
export * from "./PopupSuggestedExerciseSwapContainerAlternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1658a9c2",
  null
  
)

export default component.exports